<template>
  <loading-overlay v-if="isLoading"></loading-overlay>
  <div v-else class="col-md-6 offset-md-3">
    <!-- Error Alert -->
    <danger-alert :errors="errors"></danger-alert>

    <form v-on:submit.prevent="createKiosk" class="col-md-12">
      <div class="form-group">
        <label for="kiosk-name">Kiosk Name</label>
        <input
          type="text"
          class="form-control"
          v-model="kiosk.name"
          placeholder="Name"
          id="kiosk-name"
          name="kiosk-name"
        />
      </div>

      <div class="form-group">
        <label for="kiosk-icon">Kiosk Icon</label>
        <b-form-file id="kiosk-icon" v-model="kiosk.icon" class="mt-3" accept="image/jpeg, image/png" plain></b-form-file>
        <div class="mt-3">Selected file: {{ kiosk.icon ? kiosk.icon.name : '' }}</div>
      </div>

      <div class="form-group">
        <router-link :to="{ name: 'KioskIndex' }" tag="button" role="button" class="btn btn-light mr-1">Back</router-link>
        <input type="submit" class="btn btn-primary" value="Submit" />
      </div>
    </form>
  </div>
</template>

<script>
import { KioskService } from '@/common/services/kiosk.service';
import DangerAlert from '@/common/components/danger-alert.vue';
import commonMixin from '@/mixins/common-mixin';
import LoadingOverlay from '@/common/components/loading-overlay.vue';
import PermissionsService from '@/common/services/user_permissions.service';

export default {
  name: 'KioskNew',
  components: {
    'danger-alert': DangerAlert,
    LoadingOverlay,
  },
  created() {
    if (PermissionsService.isAdmin()) {
      this.isLoading = false;
    } else {
      this.$router.push({ name: 'HomeIndex' });
    }
  },
  data() {
    return {
      isLoading: true,
      kiosk: {
        name: '',
      },
      errors: [],
    };
  },
  mixins: [commonMixin],
  methods: {
    createKiosk() {
      KioskService.create(this.kiosk)
        .then((response) => {
          if (this.kiosk.icon) {
            const formData = new FormData();
            formData.set('kiosk[icon]', this.kiosk.icon);
            return KioskService.multipartEdit(response.data.id, formData);
          }
          return response;
        })
        .then((response) => {
          this.$router.push({ name: 'KioskShow', params: { id: response.data.id } }, () => {
            this.successGrowl('Created Kiosk', `Successfully created ${response.data.name}!`);
          });
        })
        .catch((err) => { this.errors = err.response.data.error; });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
